import React, { useState, useEffect } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import {
	Box,
	Button,
	Card,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Link,
	Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import { DatePicker } from '@material-ui/pickers';
import Format from 'date-fns/format';
import axios from 'axios';
import { ReportingService } from '../../../utils/web_config_2';
import { useAuthUser } from '../../../hooks/useUserToken';
import { LoadingScreen } from '../atoms/loading-card';

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up('sm')]: {
			marginLeft: 250,
		},
	},
}));

function StepOneTable({
	loading = false,
	startDate,
	endDate,
	data,
}) {
	if (loading) return <LoadingScreen />;

	return (
		<Card>
			<MUIDataTable
				title={
					<div>
						From {startDate.value} to {endDate.value}
					</div>
				}
				data={data}
				columns={[
					{
						name: 'Route',
					},
					{
						name: 'Plate Number',
					},
					'Driver names',
					'Max Capacity',
					'Actual Revenue',
				]}
				options={{
					filterType: 'checkbox',
				}}
			/>
		</Card>
	);
}

export default function GeneralPerformanceReport() {
	const [isLoading, setIsLoading] = useState(true);

	const [showFilterDialog, setShowFilterDialog] = useState(false);
	const [reportLoad, setReportLoad] = useState(false);
	const [authUser, setAuthUser] = useState();
	const [data, setData] = useState([]);

	const [startDate, setStartDate] = useState({
		value: Format(new Date(), ['yyyy-MM-dd']),
		error: '',
	});
	const [endDate, setEndDate] = useState({
		value: Format(new Date(), ['yyyy-MM-dd']),
		error: '',
	});

	const styles = useStyles();

	const { token, organization } = useAuthUser();

	async function filter_report() {
		setIsLoading(true);

		setReportLoad(true);

		try {
			let req = {
				start_date: startDate.value,
				end_date: endDate.value,
				organization_id: organization.organization_id,
			};

			axios.defaults.baseURL = new ReportingService().BASE_URL;
			const reportInstance = axios.create(
				new ReportingService().setHeaders(token)
			);

			let {
				data: { data },
			} = await reportInstance.post('/api/v1/performance/general', req);

			let formattedRows = [];
			for (let item of data) {
				formattedRows.push([
					item.route,
					item.plate_number,
					item.driver,
					item.max_capacity,
					item.actual_revenue,
				]);
			}

      console.log({formattedRows})

			setData(formattedRows);
			setIsLoading(false);
		} catch (error) {
      console.log(error)
			setData([]);
			setIsLoading(false);
		}

		setShowFilterDialog(false);
		setReportLoad(false);
	}

	useEffect(() => {
		let op = localStorage.getItem('nx_op');
		if (!op) return;

		filter_report();

		setAuthUser(JSON.parse(op));
	}, []);

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div>
				<div className={styles.root}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						paddingBottom={'40px'}
					>
						<Typography variant='h5' color='default'>
							<b>
								General Performance Report
							</b>
						</Typography>

						<Button
							onClick={() => setShowFilterDialog(true)}
							color='primary'
							variant='contained'
						>
							Filter
						</Button>
					</Box>
						<StepOneTable
							startDate={startDate}
							endDate={endDate}
							data={data}
							loading={isLoading}
						/>
				</div>

				<Dialog
					maxWidth='sm'
					fullWidth
					open={showFilterDialog}
					onClose={() => {
						setShowFilterDialog(false);
					}}
					aria-labelledby='filter'
					aria-describedby='filter'
				>
					<DialogTitle id='filter'>{'Filter'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='Start date'
										value={startDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											setStartDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='End date'
										value={endDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											setEndDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={() => {
								setShowFilterDialog(false);
							}}
							color='secondary'
						>
							<Typography>Close</Typography>
						</Button>

						<Button
							onClick={() => {
								filter_report();
							}}
							color='primary'
							variant='contained'
						>
							{reportLoad ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								<Typography>View</Typography>
							)}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</MuiPickersUtilsProvider>
	);
}
